import { setQueue, setBackup, setQueueSort, setWholeQueue, setQueueSource } from '../features/queueSlice';
import { fetchWithDefaults } from '../config/fetchDefault';
import { setActiveFilter } from './appSetup';
import store from './../store/store'
import { filterOptionTypes } from './genericUtils';

const updateLeadInfo = async (queue, column, data, leadId, dispatch, type)=>{

    const updatedArray = queue.map(item => {
        // Check if the current item's ids matches the targetTagId
        if (item.lead_id === leadId) {
            // Return a new object with the updated tag_ids
            return {
                ...item,
                [column]: data
            };
        } else {
            // If it doesn't match, return the item as is
            return item;
        }

    });
    if(type==='backup'){
        dispatch(setBackup(updatedArray));
    }
    else{
        dispatch(setQueue(updatedArray));
    }
    return true;
}
const viewFlowData= async (id, setFlowData, leadId)=>{
    try {
        const response = await fetchWithDefaults(`/flowInfo?lead=${leadId}`);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const jsonData = await response.json();
        setFlowData(jsonData);

    } catch (error) {
        console.error('Error fetching data:', error);
    }
}
function removeKeys(obj, keysToRemove) {
    // Loop through the keys in the array
    keysToRemove.forEach((key) => {
      // Check if the key exists in the object
      if (obj.hasOwnProperty(key)) {
        // If it exists, delete the key
        delete obj[key];
      }
    });
    return obj;
}
const updateLeadData = async (field, value, leadId, agentId) => {
    try {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify({
                agent: agentId,
                lead:leadId,
                column:field,
                value:value
            })
        };
        const response = await fetchWithDefaults('/updateLead', requestOptions);

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const jsonData = await response.json();
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}
const handleUpdateQueueLead=(field,value,leadId,queue,dispatch)=>{
    const updatedData = queue.map(item => {
    if (item.lead_id === leadId) {
        // Create a new object with the updated field
        return {
            ...item, // Copy all existing properties of the item
            [field]: value // Update the specified field
        };
    }
    return item;
    });
    dispatch(setQueue(updatedData));
    //return updatedData;
}

const removeTag= async (tagIdToRemove,setSelectedTags,handleLeadData,selectedTags)=>{
    //const tagRemoved=await removeTagFromLead(tagIdToRemove, agentId, leadData[0].lead_id);

    //if(tagRemoved){
        const updatedTags = selectedTags.filter(tag => tag.id !== tagIdToRemove);
        // Update the state with the filtered array
        setSelectedTags(updatedTags);
        handleLeadData('tag_ids',updatedTags);
   // }*/
}
const addTag= (tag, queue, leadId,dispatch,selectedTags, handleLeadData, backUp) => {
    //addTagToLead(setSelectedTags, selectedTags, tag);
    let tags;
    if(selectedTags.length > 0){
        tags=[selectedTags[0],tag];
    }
    else{
        tags=[tag];
    }


    //setSelectedTags([...selectedTags, tag]);
    const newarr=[...selectedTags, tag];

    handleLeadData('tag_ids',newarr[0]);
    const formattedString = tags
    .map(item => `${item.id}*${item.name}`)
    .join(',');

    updateLeadInfo(queue,'tag_ids',formattedString,leadId, dispatch, 'queue')
    updateLeadInfo(backUp,'tag_ids',formattedString,leadId, dispatch, 'backup');
}
const updateStatusName=(name, handleLeadData, setSuccessTrigger)=>{
    handleLeadData('status_name',name);
    setSuccessTrigger(true);
}

const fetchQueue = async (agentId, dispatch, filter='Last 90 Days') => {
    // console.log('fetchQueue', {agentId, dispatch, filter})

    try {
        setActiveFilter(filter, dispatch);

        const data = store.getState()
        const selectedOptions = data.filterSearch.selectedOptions

        const filterOptions = {}

        for (let index = 0; index < selectedOptions.length; index++) {
            const opn = selectedOptions[index];
            const key = opn.option

            if(!filterOptions[key]){
                filterOptions[key] = []
            }

            filterOptions[key].push(opn.search)
        }

        const response = await fetchWithDefaults('/queue/callQueue',{
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                agent: agentId,
                filterOptions
            })
        })

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const jsonData = await response.json();
        const {wholeQueue, queue} = jsonData

        dispatch(setQueueSource({
            endpoint:'/queue/callQueue',
            body: {
                agent: agentId,
            }
        }))

        dispatch(setQueue(queue ?? []));
        dispatch(setBackup(queue ?? []));
        dispatch(setWholeQueue(wholeQueue ?? []))
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

const getLeadsByTimePeriod = async (timePeriod, agentId, dispatch) => {
    try {
        const data = store.getState()
        const selectedOptions = data.filterSearch.selectedOptions

        const filterOptions = {}

        for (let index = 0; index < selectedOptions.length; index++) {
            const opn = selectedOptions[index];
            const key = opn.option

            if(!filterOptions[key]){
                filterOptions[key] = []
            }

            filterOptions[key].push(opn.search)
        }

        const response = await fetchWithDefaults(`/queue/daysPast`,{
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                agent: agentId,
                days: timePeriod,
                filterOptions
            })
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        dispatch(setQueueSource({
            endpoint:'/queue/daysPast',
            body: {
                agent: agentId,
                days: timePeriod,
            }
        }))

        const jsonData = await response.json()

        return jsonData
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

const leadTimePeriodsFilterOptions = [
    {
        name: "Last 90 Days",
        value: 90
    },
    {
        name: "Last 6 Months",
        value: 180
    },
    {
        name: "Last 9 Month",
        value: 270
    },
    {
        name: "Last 1 Year",
        value: 365
    },
    {
        name: "Last 2 Years",
        value: 730
    },
    {
        name: "Last 3 Years",
        value: 1095
    },
]

const leadCardTabOptions = Object.freeze({
    SCRIPT: Symbol('SCRIPT'),
    TEXT: Symbol('TEXT'),
    EMAIL: Symbol('EMAIL'),
    NOTES: Symbol('NOTES'),
    QUOTE: Symbol('QUOTE'),
    RECORDING: Symbol('RECORDING'),
})
/**
 *
 * @param {ListFilter[]} filterListOptions
 * @param {RangeFilter[]} filterRangeOptions
 * @param {PaginationOptions} paginationOptions
 * @param {SortOptions[]} sortOptions
 * @param {String} agentIdNumber
 * @param {PreDefinedFilter} predefinedFilter
 */
const getLeadsByFilterOptions = async(filterListOptions, filterRangeOptions, paginationOptions, sortOptions, agentIdNumber, predefinedFilter) => {
    const range = filterRangeOptions.map( r => {
        return {
            field: r.field,
            start: r.start,
            end: r.end
        }
    })

    const filterOptions = {}

    for (const option of filterListOptions) {
        filterOptions[option.field] = option.list
    }

    // console.log('getLeadsByFilterOptions', {filterListOptions,filterRangeOptions,paginationOptions,sortOptions,predefinedFilter})

    const requestOptions = {
        method: 'POST',
        body: JSON.stringify({
            agent: agentIdNumber,
            page: paginationOptions.page,
            numPerPage: paginationOptions.numPerPage,
            sortBy: sortOptions,
            filterOptions,
            range,
            predefinedFilters: predefinedFilter.params === null ? null : predefinedFilter
        })
    }

    try {
        const response = await fetchWithDefaults('/queue/leadFilter', requestOptions)

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const jsonData = await response.json()

        return jsonData
    } catch (error) {
        console.error('Error fetching data:', error)
    }
}

/**
 * @typedef {Object} SortOption
 * @property {string} field
 * @property {string} direction One of "ASC", "DESC"
 */

/**
 *
 * @param {RangeFilter} date_assigned
 * @param {RangeFilter} lead_age
 * @param {ListFilter} state
 * @param {RangeFilter} last_contacted
 * @param {RangeFilter} never_contacted
 * @param {RangeFilter} amount_contacted
 * @param {ListFilter} tags
 * @param {ListFilter} lead_type
 * @param {ListFilter} lead_level
 * @param {ListFilter} lead_status
 * @param {PreDefinedFilter} predefined_filter
 * @param {number} page
 * @param {number} numPerPage
 * @param {SortOption | Array<SortOption> | null | undefined} sortOptions
 */
const filterLeadsPayload = (date_assigned, lead_age, state, last_contacted, never_contacted, amount_contacted, tags, lead_type, lead_level, lead_status, predefined_filter, page, numPerPage, sortOptions) => {
    const allActiveFilters = [date_assigned, lead_age, state, last_contacted, never_contacted, amount_contacted, tags, lead_type, lead_level, lead_status]
        .filter(f => f?.active)

    let filterListOptions = []
    let filterRangeOptions = [];
    let paginationOptions = {
        page,
        numPerPage
    }
	if (sortOptions && !Array.isArray(sortOptions)) {
		sortOptions = [sortOptions];
	}
	if (!sortOptions || (Array.isArray(sortOptions) && sortOptions.length === 0)) {
		sortOptions = [{
		    field: 'date_assigned',
		    direction: 'DESC'
		}];
	}

    if (allActiveFilters.length > 0) {
        filterRangeOptions = allActiveFilters.filter(f => f.filterOptionType === filterOptionTypes.RANGE)
                                            .map(f => {
                                                // Convert never_contacted to amount_contacted for API call
                                                let field = f.field;
                                                if (f.field === 'never_contacted') {
                                                    field = 'amount_contacted';
                                                }
                                                return {
                                                    ...f,
                                                    field: f.excluded ? `exclude_${field}` : field
                                                }
                                            })

        filterListOptions = allActiveFilters.filter(f => f.filterOptionType === filterOptionTypes.LIST)
                                            .map(f => ({
                                                ...f,
                                                field: f.excluded ? `exclude_${f.field}` : f.field
                                            }))
    }

    return { filterListOptions, filterRangeOptions, paginationOptions, sortOptions, predefinedFilter: {...predefined_filter} }
}

export { updateLeadInfo, viewFlowData, updateLeadData, removeKeys, handleUpdateQueueLead, removeTag, updateStatusName, addTag, getLeadsByTimePeriod, leadTimePeriodsFilterOptions, fetchQueue, leadCardTabOptions, getLeadsByFilterOptions, filterLeadsPayload};
